import { SavingLabel } from 'owa-locstrings/lib/strings/savinglabel.locstring.json';
import { SavingToCloudLabel } from './tryExitSxSEditModeOrchestrator.locstring.json';
import loc from 'owa-localize';
import { onEditModeChange } from '../actions/internalActions';
import { tryExitSxSEditMode } from '../actions/publicLazyActions';
import synchronizeWacAttachment, { SyncWacResult } from '../services/synchronizeWacAttachment';
import { EditMode } from '../store/schema/SxSEditState';
import getOrCreateSxSStoreData from '../store/Store';
import { ExitedEditModeEvent } from '../utils/eventNames';
import { getMailboxRequestOptions } from 'owa-request-options-types';
import { lazySetPreviewLoading, lazySetWacPreviewState, PreviewPaneMode } from 'owa-sxsdata';
import { orchestrator } from 'satcheljs';

async function tryExitSxSEditModeOrchestrator(sxsId: string) {
    const sxsStore = getOrCreateSxSStoreData(sxsId);
    if (!sxsStore.viewState.previewPane || sxsStore.editState.mode !== EditMode.Edit) {
        return;
    }

    if (sxsStore.viewState.previewPane.mode === PreviewPaneMode.Wac) {
        const wacPreviewState = sxsStore.viewState.previewPane;
        const originalValues = {
            wacUrl: wacPreviewState.wacUrl,
            jsApiInfo: wacPreviewState.jsApiInfo,
            accessToken: wacPreviewState.accessToken,
            accessTokenTtl: wacPreviewState.accessTokenTtl,
            additionalParameters: wacPreviewState.additionalParameters,
            deprecatedTokenAndParameters: wacPreviewState.deprecatedTokenAndParameters,
        };

        onEditModeChange(EditMode.Saving, sxsStore.editState.itemId, sxsId);
        const setPreviewLoading = await lazySetPreviewLoading.import();
        setPreviewLoading(
            sxsStore.viewState,
            sxsStore.extendedViewState.isCloudy ? loc(SavingToCloudLabel) : loc(SavingLabel)
        );

        const attachmentId = sxsStore.extendedViewState.attachmentId;
        const syncWacResult = await synchronizeWacAttachment(
            attachmentId.Id,
            getMailboxRequestOptions(attachmentId.mailboxInfo)
        );

        if (syncWacResult === SyncWacResult.Success) {
            onEditModeChange(EditMode.View, sxsStore.editState.itemId, sxsId);
        } else {
            // revert to Edit mode
            const setWacPreviewState = await lazySetWacPreviewState.import();
            setWacPreviewState(
                sxsStore.viewState,
                originalValues.wacUrl,
                originalValues.jsApiInfo,
                originalValues.accessToken,
                originalValues.accessTokenTtl,
                originalValues.additionalParameters,
                originalValues.deprecatedTokenAndParameters,
                null, // clickTime
                null, // readOnly info
                sxsStore.viewState.previewPane
            );
            onEditModeChange(EditMode.Edit, sxsStore.editState.itemId, sxsId);
        }

        sxsStore.eventManager.emit(ExitedEditModeEvent, sxsStore.editState.mode !== EditMode.Edit);
    }
}

orchestrator(tryExitSxSEditMode, async actionMessage => {
    const { sxsId } = actionMessage;
    await tryExitSxSEditModeOrchestrator(sxsId);
});

// export for unit tests
export { tryExitSxSEditModeOrchestrator };
